import { memo, useCallback, useEffect, useMemo, useState } from "react";
import './nodeStyles.css';
import { Button, List, Popover } from "antd";
import Option from "../../assets/icons/Menu.svg";
import addNodes from "../../assets/icons/addNodes.svg";
import { Image } from 'react-bootstrap';
import DeleteConfirmModel from "../dashboard/DashboardMain/DeleteOpenModel/DeleteConfirmModel";
import { findPreviousNode } from "../../utilities/Nodes/getConnectedChildNodes";
import { useTranslation } from "react-i18next";
import { handleAdd, handleDeLinkNode, handleRemoveSingleConnected } from "../../utilities/Nodes/commonFunctions";
import { calculatePopoverStyles } from "../../utilities/utils";
import { useFlowDataContext } from "../../context/workbench/FlowDataContext";
import { useViewPortContext } from "../../context/workbench/ViewPortContext";
import { useZoomContext } from "../../context/workbench/ZoomContext";

export const ActionPopover = memo(function ActionPopover({id, data, setIsEditing}: {id: string, data: any, setIsEditing: any}) {
    const { t } = useTranslation('common');
    const flowDataContext = useFlowDataContext();
    const zoomContext = useZoomContext()
    // const viewPortContext = useViewPortContext();

    const [open, setOpen] = useState<boolean>(false);
    const [isDeleteModelOpen, setIsDeleteModelOpen] = useState<boolean>(false);

    // Calculate popover styles based on zoom level
    const popoverStyle = useMemo(() => calculatePopoverStyles(zoomContext?.workbenchZoomLevel), [zoomContext?.workbenchZoomLevel]);
    const previousNode = useMemo(() => findPreviousNode(id, flowDataContext?.edges, flowDataContext?.nodes), [flowDataContext?.edges, flowDataContext?.nodes, id]);

    // useEffect(() => {
    //     setOpen(false);
    // }, [viewPortContext?.viewportXvalue, viewPortContext?.viewportYvalue])

    const handleVisibleChange = useCallback(() => {
        setOpen((current) => !current);
    }, []);

    const handleOnDeleteConfirm = useCallback(() => {
        handleRemoveSingleConnected(data, id); 
        setOpen(false); 
    }, [data, id]);

    const handleOnCancel = useCallback(() => {
        setIsDeleteModelOpen(false);
    }
    , []);

    const actionContent = useMemo(() => (
        <div className="card-action-options">
            <List className="w-100">
                <List.Item>
                    <Button className="action-btn" onClick={() => { setOpen(false); setIsEditing(true) }}>
                        {t('buttons.edit')}
                    </Button>
                </List.Item>
                <List.Item>
                    <Button className="action-btn" onClick={() => { setOpen(false); setIsDeleteModelOpen(true) }}>
                        {t('buttons.delete')}
                    </Button>
                </List.Item>
                {previousNode !== null &&
                    <List.Item>
                        <Button className="action-btn" onClick={() => { handleDeLinkNode(data, id); setOpen(false); }}>
                            {t('buttons.delink')}
                        </Button>
                    </List.Item>}
            </List>
        </div>
    ), [data, id, previousNode, setIsEditing, t]);

  return (
    <>
        <Popover
            content={actionContent}
            trigger="hover"
            arrow={false}
            open={open}
            placement="right"
            overlayClassName="add-node-popover"
            onOpenChange={handleVisibleChange}
            autoAdjustOverflow
            overlayInnerStyle={popoverStyle.overlayInnerStyle}
            overlayStyle={popoverStyle.overlayStyle}
        >
            <Button className="action-btn">
                <Image src={Option} alt='Option' />
            </Button>
        </Popover>
        <div>
            <DeleteConfirmModel
                visible={isDeleteModelOpen}
                onConfirm={handleOnDeleteConfirm}
                onCancel={handleOnCancel}
                title={t('deleteModal.title')}
                content={t('deleteModal.description')}
                okText={t('buttons.confirm')}
                cancelText={t('buttons.cancel')} 
            />
        </div>
    </>
  )
})

export const AddButtonPopoverAction = memo(function AddButtonPopoverAction ({data, id}: any){
    const { t } = useTranslation('common');
    const viewPortData = useViewPortContext();
    const flowDataContext = useFlowDataContext();

    const [visible, setVisible] = useState(false);

    const previousNode = useMemo(() => findPreviousNode(id, flowDataContext?.edges, flowDataContext?.nodes), [flowDataContext?.edges, flowDataContext?.nodes, id]);
    
    useEffect(() => {
        setVisible(false);
    }, [viewPortData?.viewportXvalue, viewPortData?.viewportYvalue])

    const handleVisibleChange = useCallback((newVisible: boolean) => {
        setVisible(newVisible);
    }, []);

    const content = useMemo(() => (
        <div className="add-options-menu">
            <Button
                className="add-option-item"
                onClick={() => { handleAdd('paragraph', data, id); setVisible(false); }}
            >
                <span>{t('buttons.workbench.paragraph')}</span>
            </Button>
            <Button
                className="add-option-item"
                onClick={() => { handleAdd('steps', data, id); setVisible(false); }}
            >
                <span>{t('buttons.workbench.steps')}</span>
            </Button>
            {(previousNode?.type === "questionNode" || previousNode === null) &&
                <Button
                    className="add-option-item"
                    onClick={() => { handleAdd('yesNo', data, id); setVisible(false); }}
                >
                    <span>{t('buttons.workbench.boolean')}</span>
                </Button>
            }
            <Button
                className="add-option-item"
                onClick={() => { handleAdd('link', data, id); setVisible(false); }}
            >
                <span>{t('buttons.workbench.linkModel')}</span>
            </Button>
        </div>
    ), [data, id, previousNode, t]);

    return (
        <Popover
            content={content}
            trigger="hover"
            placement="right"
            arrow={false}
            overlayClassName="add-node-popover"
            open={visible}
            onOpenChange={handleVisibleChange}
        >
            <Image src={addNodes} alt="addIcon" className="addIcon pe-2" />
        </Popover>
    )
})